export const replaceWindowUrl = (url: string): void => {
    window.history.replaceState({}, '', url);
};
